module.exports = __webpack_public_path__ + "static/media/cartouche_homme.429761ba.PNG";